<script>
  import firebase, {functions} from "./firebase"

  const formData = {
    name: '',
    email: '',
    content: '',
  }

  const errors = {
    name: null,
    email: null,
    content: null,
  }

  function handleOnSubmit(e) {
    e.preventDefault()

    // localの場合 emulator を使う
    if (!__myapp.env.IS_PROD) {
      functions.useFunctionsEmulator("http://localhost:5001");
    }

    const onCallContact = functions.httpsCallable('onCallContact');

    onCallContact(formData).then(result => {
      const resultData = result.data
      if (resultData.status === "success") {
        formData.name = ''
        formData.email = ''
        formData.content = ''
        errors.name = null
        errors.email = null
        errors.content = null
        window.alert('お問い合わせを受け付けました')
      } else {
        if (resultData.errors) {
          errors.name = resultData.errors.name
          errors.email = resultData.errors.email
          errors.content = resultData.errors.content
        }
      } 
    }).catch(e => {
      console.log(e)
    })
  }
</script>

<form on:submit={handleOnSubmit}>
  <div class="field">
    <label for="contact-form-name">お名前</label>
    <span>必須</span>
    <div class="input">
      <input type="text" id="contact-form-name" placeholder="山田 太郎" bind:value={formData.name} class="{errors.name ? 'error' : ''}">
      {#if errors.name}
        <p class="error">{errors.name}</p>
      {/if}
    </div>
  </div>
  <div class="field">
    <label for="contact-form-email">メールアドレス</label>
    <span>必須</span>
    <div class="input">
      <input type="text" id="contact-form-email" placeholder="example@goopar.jp" bind:value={formData.email} class="{errors.email ? 'error' : ''}">
      {#if errors.email}
        <p class="error">{errors.email}</p>
      {/if}
    </div>
  </div>
  <div class="field">
    <label for="contact-form-content">内容</label>
    <span>必須</span>
    <div class="input">
      <textarea id="contact-form-content" placeholder="お問い合わせ内容" bind:value={formData.content} class="{errors.content ? 'error' : ''}"></textarea>
      {#if errors.content}
        <p class="error">{errors.content}</p>
      {/if}
    </div>
  </div>
  <div class="action">
    <input type="submit" value="送信する">
  </div>
</form>
